import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import LeaseApiService from '../../services/apiService';
import { AsyncPaginate } from 'react-select-async-paginate';

const UnitDetails = ({ tableLoading, floorList, furnishing, setLeaseCheck, leaseCheck, setSupplierCheck, landlordList, unitViewList, supplierCheck, bedRoomList, setTransectionData, transectionData, readOnly = false }) => {
    const { t } = useTranslation();
    const ITEMS_PER_PAGE = 100;
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            if (name === "firstName" || name === "lastName") {
                updatedData.fullName = `${updatedData.firstName || ""} ${updatedData.lastName || ""}`.trim();
            }
            return updatedData;
        });
    };
    // All In Price = base price + Registration Fee % of it. allPriceBase keeps
    // the last raw price the user typed, separate from the fee-inclusive
    // total shown in the field, so recalculating on a Registration Fee change
    // doesn't re-add the fee on top of an already-fee-inclusive number.
    const recalcAllInPrice = (base, percent) => {
        const baseNum = parseFloat(base) || 0;
        const percentNum = parseFloat(percent) || 0;
        const total = baseNum + (baseNum * percentNum) / 100;
        setTransectionData((prev) => ({ ...prev, allPriceBase: baseNum, allPrice: total ? total.toFixed(2) : prev.allPrice }));
    };
    const handleAllPriceBlur = () => recalcAllInPrice(transectionData?.allPrice, transectionData?.registrationFee);
    const handleRegistrationFeeBlur = () => recalcAllInPrice(transectionData?.allPriceBase ?? transectionData?.allPrice, transectionData?.registrationFee);
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "landlordId") {
            setTransectionData(prev => ({ ...prev, [name]: value, saller: { label: value?.value, value: value?.label } }));
        } else if (name === "saller") {
            setTransectionData(prev => ({ ...prev, [name]: value, landlordId: { label: value?.value, value: value?.value } }));
        } else {
            setTransectionData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleSuppChange = (val) => {
        setSupplierCheck(val);
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = landlordList;

        if (search) {
            filtered = landlordList.filter(
                (tenant) => tenant.value.toLowerCase().includes(search.toLowerCase()) || tenant.text.toLowerCase().includes(search.toLowerCase()),
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map((tenant) => ({ value: tenant?.value, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 },
        });
    };
    const loadOptionsId = (search, loadedOptions, { page }) => {
        let filtered = landlordList;

        if (search) {
            filtered = landlordList.filter(
                (tenant) => tenant.value.toLowerCase().includes(search.toLowerCase()) || tenant.text.toLowerCase().includes(search.toLowerCase()),
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map((tenant) => ({ value: tenant?.text, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 },
        });
    };
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}

                <fieldset disabled={readOnly} style={{ border: 'none', padding: 0, margin: 0 }}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.utilityRoom')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.utilityRoom} onChange={handleInputChange} name="utilityRoom" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">{t('unitMaster.unitDetailsFields.furnished')}</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.furnishing}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'furnishing', value: selectedOption })}
                            options={furnishing?.map(country => ({ value: country, label: country?.text }))}
                            isDisabled={readOnly}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.studyRoom')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.studyRoom} onChange={handleInputChange} name="studyRoom" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.laundryRoom')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.laundryRoom} onChange={handleInputChange} name="laundryRoom" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.maidRoomEnsuite')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.maidRoom} onChange={handleInputChange} name="maidRoom" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> {t('unitMaster.unitDetailsFields.plotNo')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.plotNO} onChange={handleInputChange} name="plotNO" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.bedrooms')}</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.bedRooms}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'bedRooms', value: selectedOption })}
                            options={bedRoomList?.map(country => ({ value: country, label: country?.text }))}
                            isDisabled={readOnly}
                        />
                    </div>
                    <div className='d-flex gap-3'>
                        <div className="form-check gap-3 center">
                            <input style={{ width: "20px", height: "20px" }}
                                onClick={() => handleSuppChange("Sale")} checked={supplierCheck === "Sale" ? true : false}
                                className="form-check-input" type="radio" name="flexRadioDefault" id={supplierCheck} />
                            <label className="form-check-label" for="Sale">{t('unitMaster.unitDetailsFields.sale')}</label>
                        </div>
                        <div className="form-check gap-3 center" >
                            <input className="form-check-input" style={{ width: "20px", height: "20px" }}
                                type="radio" name="flexRadioDefault" id={supplierCheck} checked={supplierCheck === "Lease" ? true : false}
                                onClick={() => handleSuppChange("Lease")}
                            />
                            <label className="form-check-label" for="Lease">{t('unitMaster.unitDetailsFields.lease')}</label>
                        </div>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.plotSize')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.plotSize} onChange={handleInputChange} name="plotSize" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.bathroom')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.bathRoom} onChange={handleInputChange} name="bathRoom" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.unitView')} *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.unitView}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'unitView', value: selectedOption })}
                            options={unitViewList?.map(country => ({ value: country, label: country?.text }))}
                            isDisabled={readOnly}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.noOfParkings')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.parking} onChange={handleInputChange} name="parking" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.floor')}</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.floor}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'floor', value: selectedOption })}
                            options={floorList?.map(country => ({ value: country, label: country?.text }))}
                            isDisabled={readOnly}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.balconyArea')}</label>
                        <input type="email" className="p-2 form-control w-75" value={transectionData?.balcony} onChange={handleInputChange} name="balcony" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.parkingPrice')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.parkingPrice} onChange={handleInputChange} name="parkingPrice" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.totalArea')} *</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.totalArea} onChange={handleInputChange} name="totalArea" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.sqftRate')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.sqftRate} onChange={handleInputChange} name="sqftRate" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.allInPrice')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.allPrice} onChange={handleInputChange} onBlur={handleAllPriceBlur} name="allPrice" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.completionDate')}</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.completionDate}
                            onChange={(date) => handleDateChange({ name: 'completionDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.registrationFees')}</label>
                        <input type="number" className="p-2 form-control w-75" value={transectionData?.registrationFee} onChange={handleInputChange} onBlur={handleRegistrationFeeBlur} name="registrationFee" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">{t('unitMaster.unitDetailsFields.rentPerAnnum')}</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.rent} onChange={handleInputChange} name="rent" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">
                            {t('unitMaster.unitDetailsFields.ownerName')}
                        </label>
                        <AsyncPaginate
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': { backgroundColor: '#F5F5F5', color: '#000' },
                                }),
                            }}
                            loadOptions={loadOptionsName}
                            defaultOptions
                            isDisabled={readOnly}
                            value={transectionData?.saller}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'saller', value: selectedOption })}
                            additional={{ page: 0 }}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">
                            {t('unitMaster.unitDetailsFields.ownerId')}
                        </label>
                        <AsyncPaginate
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': { backgroundColor: '#F5F5F5', color: '#000' },
                                }),
                            }}
                            isDisabled
                            loadOptions={loadOptionsId}
                            defaultOptions
                            value={transectionData?.landlordId}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'landlordId', value: selectedOption })}
                            additional={{ page: 0 }}
                        />
                    </div>
                </div>
                </fieldset>
            </div>
        </div>
    )
}
export default UnitDetails